import { Address } from '@models/address'

interface Action {
  field: keyof Address
  value: string
}

export function addressReducer(state: Address, action: Action): Address {
  return {
    ...state,
    [action.field]: action.value
  }
}
